// @ts-nocheck
import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'
import { ReactComponent as dashed_arrow} from '@/asset/svgs/onboarding_arrow.svg'
import { ReactComponent as drag_arrow} from '@/asset/svgs/drag_line1.svg'

export const DashedArrow = (props: SvgIconProps) => {
  return <SvgIcon {...props} component={dashed_arrow} inheritViewBox />
}

export const DragArrow = (props: SvgIconProps) => {
  return <SvgIcon {...props} component={drag_arrow} inheritViewBox />
}
